var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 107,
    viewBox: "0 0 107 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.3883 74.0841L99.4833 93.1747L93.1748 99.4832L74.0842 80.3882C66.9809 86.0825 58.1457 89.1796 49.0417 89.1667C26.8927 89.1667 8.91675 71.1907 8.91675 49.0417C8.91675 26.8927 26.8927 8.91666 49.0417 8.91666C71.1908 8.91666 89.1667 26.8927 89.1667 49.0417C89.1797 58.1456 86.0826 66.9808 80.3883 74.0841ZM71.4449 70.776C77.103 64.9574 80.2629 57.1577 80.2501 49.0417C80.2501 31.7968 66.2821 17.8333 49.0417 17.8333C31.7969 17.8333 17.8334 31.7968 17.8334 49.0417C17.8334 66.282 31.7969 80.25 49.0417 80.25C57.1578 80.2628 64.9575 77.1029 70.7761 71.4448L71.4449 70.776Z",
    fill: "#242731"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchLine);
export default __webpack_public_path__ + "static/media/search-line.92e634d5eb1d22a2ee83a98b946e0614.svg";
export { ForwardRef as ReactComponent };